<template>
    <v-chart ref="line" :options="option"/>
</template>

<script>
    import ECharts from 'vue-echarts'
    import 'echarts/lib/chart/line'
    import 'echarts-gl'

    export default {
        components: {
            'v-chart': ECharts,
        },
        name: "UserSituationLineECharts",
        props: {
                lineData:Object
        },
        watch:{
            lineData:function(newVal,oldVal){
                this.$refs.line.clear();
                this.option.series[0].data = newVal.data.data_list;
                this.option.xAxis.data = newVal.data.date_list;
                this.option.legend.data = newVal.settings.legendData;
                this.option.series[0].name = newVal.settings.legendData[0];
                this.loaded()
            }
        },
        data() {
            return {
                option: {
                    legend: {
                        left: "10%",
                        data: ['日新增(注册)']
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    grid: {
                        top: '25%',
                        bottom: '0',
                        left: '5%',
                        right: '5%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        name: '日新增(注册)',
                        data: [],
                        type: 'line'
                    }]
                }
            }
        },
        methods:{
            loading(){
                this.$refs.line.showLoading()
            },
            loaded(){
                this.$refs.line.hideLoading()
            }
        }
    }
</script>

<style scoped>
    .echarts {
        width: 100%;
        /*height: 100%;*/
    }
</style>